const TRIGGER = 'change';

const Regexp = () => {
  return {
    // 必填项
    required: {
      required: true,
      message: (window as any).vm.$t('assets.validate.required'),
      trigger: TRIGGER
    },
    // 长度不超过{maxLen}
    maxLength: (maxLen: number) => {
      return {
        max: maxLen,
        message: (window as any).vm.$t('assets.validate.maxLength', {maxLen}),
        trigger: TRIGGER
      };
    },
    // 长度不少于{minLen}
    minLength: (minLen: number) => {
      return {
        min: minLen,
        message: (window as any).vm.$t('assets.validate.minLength', {minLen}),
        trigger: TRIGGER
      };
    },
    // 电话
    phone: {
      pattern: /(^1\d{10}$)|(^0\d{2}-\d{7,8}$)/,
      message: (window as any).vm.$t('assets.validate.phone'),
      trigger: TRIGGER
    },
    // 邮箱
    email: {
      pattern: /^([a-zA-Z0-9_\.\-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,8}){1,2})$/,
      message: (window as any).vm.$t('assets.validate.email'),
      trigger: TRIGGER
    }
  };
};

export { Regexp };
